import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/uptime/configProvider/upsert/uptime.configProvider.upsert.mutation.gql"
import { UPTIME_CONFIG_REFETCH_QUERIES } from "@/v2-backoffice-client/uptime/config/uptime.config.query"
import type {
  UptimeConfigProviderUpsertMutation,
  UptimeConfigProviderUpsertMutationVariables,
} from "@/v2-backoffice-client/uptime/configProvider/upsert/__types__/uptime.configProvider.upsert.mutation"

type Options = MutationHookOptions<
  UptimeConfigProviderUpsertMutation,
  UptimeConfigProviderUpsertMutationVariables
>

export function useUptimeConfigProviderUpsertMutation(options?: Options) {
  return useMutation<
    UptimeConfigProviderUpsertMutation,
    UptimeConfigProviderUpsertMutationVariables
  >(mutation, {
    refetchQueries: [...UPTIME_CONFIG_REFETCH_QUERIES],
    awaitRefetchQueries: true,
    ...options,
  })
}
